package com.sddamico.draftmachine.util

private val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")

/**
 * Client copy of the server's `EmailAddress` rule. The wizard creates teams only at its last step,
 * so it has to catch an address the server would refuse before any draft row exists.
 */
fun isValidEmail(raw: String): Boolean = raw.trim().let { it.length <= 255 && EMAIL_REGEX.matches(it) }
